// calendarAuswahl.ts — K6: die reinen Helfer des Kalender-Auswahlmodus.
// Bewusst ohne React, damit CalendarView, MobileCalendarShell, der Termine-
// Reiter des Vorgangs und die Mail-Leiste dieselbe Wahrheit teilen und die
// Regeln testbar bleiben.

import type { CalendarGridEvent } from "./types";

/**
 * Ein im Auswahlmodus angeklickter Termin — genau das, was ein Aufrufer zum
 * Verknüpfen braucht. Bewusst NICHT das ganze Grid-Event: die Aufrufer sollen
 * sich nicht an interne Grid-Felder binden.
 */
export interface TerminAuswahl {
    mailbox: string;
    graphEventId: string;
    subject: string;
    start: Date;
    end: Date;
    allDay: boolean;
}

/** Grid-Event → Auswahl-Nutzlast. */
export function auswahlAusGridEvent(e: CalendarGridEvent): TerminAuswahl {
    return {
        mailbox: e.mailbox,
        graphEventId: e.id,
        subject: e.title ?? "",
        start: e.start,
        end: e.end,
        allDay: !!e.allDay,
    };
}

/**
 * Schlüssel eines Termins über (Postfach, Event-Id) — identisch zum
 * `metaKey`-Muster im CalendarStateContext: Postfach kleingeschrieben, die
 * Graph-Event-Id bleibt unverändert (sie IST case-sensitiv).
 */
export function verknuepftKey(mailbox: string, eventId: string): string {
    return `${(mailbox ?? "").toLowerCase()}:${eventId ?? ""}`;
}

/** Hängt dieser Termin schon am aufrufenden Ziel? */
export function istBereitsVerknuepft(
    e: { mailbox: string; id?: string; graphEventId?: string },
    liste: { mailbox: string; graphEventId: string }[] | undefined,
): boolean {
    if (!liste || liste.length === 0) return false;
    const key = verknuepftKey(e.mailbox, e.graphEventId ?? e.id ?? "");
    return liste.some((t) => verknuepftKey(t.mailbox, t.graphEventId) === key);
}
